import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
        padding: '0'
    },
    gridItem: {
        padding: '0'
    },
    buttonItem: {
        marginTop: theme.spacing(2),

    },
    button: {

        //height: '56px'
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    errorText: {
        color: '#ff0000'
    }
});

interface IEnrolmentHelpProps {
}

interface IEnrolmentHelpState {
}

export class EnrolmentHelp extends Component<IEnrolmentHelpProps & WithStyles<typeof styles>, IEnrolmentHelpState> {
    constructor(props) {
        super(props);
    }

    public componentDidMount() {
    }

    componentWillUnmount() {
    }

    public render() {
        const classes = this.props.classes;

        return (
            <Grid className={classes.root} container>
                <Grid item xs={12}>
                    <Grid className={classes.root} container spacing={1}>
                        <Grid item xs={12}>
                            <Typography>
                                Please ensure that you read the Hull College Conditions of Enrolment and Fee Regulations by visiting the page relevant to your studies below:
                            </Typography>
                            <Typography>
                                <ul>
                                    <li><a href="https://www.hull-college.ac.uk/enrolment">FE Fee Resulations</a></li>
                                    <li><a href="https://www.hull-college.ac.uk/study/degree-level/fees-finance">HE Fee Resulations</a></li>
                                </ul>
                            </Typography>
                            <Typography>
                                Helpful Contacts for your Enrolment Experience - <a target="_blank" href="api/Enrolment/GetHelpfulContacts">Click here</a>
                            </Typography>
                            <Typography>
                                Online Enrolment Form – A Little Extra Help  - <a target="_blank" href="api/Enrolment/GetHelpForOnlineForm">Click here</a>
                            </Typography>
                            <Typography>
                                Online Enrolment Form – A Little Extra Help (14-16 Students) - <a target="_blank" href="api/Enrolment/GetHelpForOnlineForm1416">Click here</a>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Button color="primary" variant="contained" className={classes.button} href={'/'} fullWidth>
                                Return to enrolment home
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(EnrolmentHelp);

